import gqLogo from 'assets/images/reviews/reviews-gq.png';
import MarieclaireLogo from 'assets/images/reviews/reviews-marie.png';
import nyPostLogo from 'assets/images/reviews/reviews-nypost.png';
import vogueLogo from 'assets/images/reviews/reviews-vogue.png';

export const pressExcerpts1 = {
  link: '',
  content: `“Prose’s bespoke blends are made to order—what’s fresher?”`,
  imgAlt: 'Vogue',
  imgSrc: vogueLogo,
};

export const pressExcerpts2 = {
  link: '',
  content: `“Considers all the variables that make for a good hair day.”`,
  imgAlt: 'GQ',
  imgSrc: gqLogo,
};

export const pressExcerpts3 = {
  link: '',
  content: `“From base to end product, you’re receiving something custom to you.”`,
  imgAlt: 'The New York Post',
  imgSrc: nyPostLogo,
};
export const pressExcerpts4 = {
  link: '',
  content: `“Trying Prose was a huge game changer for me.”`,
  imgAlt: 'Marie Claire',
  imgSrc: MarieclaireLogo,
};
